import {
	CollapsibleContent as BaseCollapsibleContent,
	type CollapsibleContentProps as BaseProps,
	// biome-ignore lint/style/noRestrictedImports: re-export
} from "@radix-ui/react-collapsible";
import { cx } from "@suse-o11y/class-variance";
import { px } from "@suse-o11y/px";
import React from "react";

export interface CollapsibleContentProps extends BaseProps {
	slideDownFromHeight?: number | string;
	slideDownFromOpacity?: number;
	slideUpToHeight?: number | string;
	slideUpToOpacity?: number;
}

export const CollapsibleContent = React.forwardRef<HTMLDivElement, CollapsibleContentProps>(
	(
		{
			className,
			slideDownFromHeight = 0,
			slideDownFromOpacity = 0,
			slideUpToHeight = 0,
			slideUpToOpacity = 0,
			style,
			...props
		},
		ref,
	) => (
		<BaseCollapsibleContent
			className={cx("motion-safe:animate-slide-down motion-safe:state-closed:animate-slide-up", className)}
			ref={ref}
			style={
				{
					...style,
					"--slide-down-from-height": px(slideDownFromHeight),
					"--slide-down-from-opacity": slideDownFromOpacity,
					"--slide-up-to-height": px(slideUpToHeight),
					"--slide-up-to-opacity": slideUpToOpacity,
				} as React.CSSProperties
			}
			{...props}
		/>
	),
);

if (import.meta.env.DEV) {
	CollapsibleContent.displayName = "CollapsibleContent";
}
